import { useBoundField, type FieldProps } from "../field-state";

export function TextArea(props: FieldProps<"s-text-area">) {
  const { field, error, dismissError, handleBlur } = useBoundField<string>();
  return (
    <s-text-area
      {...props}
      name={field.name}
      value={field.state.value}
      error={error}
      onFocus={dismissError}
      onInput={(event) => {
        dismissError();
        field.handleChange(event.currentTarget.value);
      }}
      onBlur={handleBlur}
    />
  );
}
